
import { components } from '~/slices'

export default {
  name: 'SportsPage',
  async asyncData({ app, $prismic, params, error, store }) {
    const sportPage = await $prismic.api.getByUID('sport_page', params.slug, {
      lang: app.i18n.localeProperties.prismic,
    })

    if (!sportPage) {
      return error({ statusCode: 404, message: 'Page not found' })
    }

    // Slug je Sprache für den Sprachumschalter setzen
    const routeParams = { [app.i18n.locale]: { slug: sportPage.uid } }
    for (const alt of sportPage.alternate_languages || []) {
      const locale = app.i18n.locales.find((l) => l.prismic === alt.lang)
      if (locale && alt.uid) {
        routeParams[locale.code] = { slug: alt.uid }
      }
    }
    await store.dispatch('i18n/setRouteParams', routeParams)

    return { sportPage }
  },
  nuxtI18n: {
    paths: {
      de: '/sport/:slug',
      en: '/sports/:slug',
    },
  },
  data() {
    return { components }
  },
  head() {
    if (this.sportPage && this.sportPage.data) {
      return {
        title: this.sportPage.data.meta_titel + ' | ATHLYZER',
        meta: [
          {
            hid: 'og-title',
            property: 'og:title',
            content: this.sportPage.data.meta_titel + ' | ATHLYZER',
          },
          {
            hid: 'description',
            name: 'description',
            content: this.sportPage.data.meta_beschreibung,
          },
          {
            hid: 'og-desc',
            property: 'og:description',
            content: this.sportPage.data.meta_beschreibung,
          },
          {
            hid: 'og-image',
            property: 'og:image',
            content: this.sportPage.data.open_graph_image
              ? this.sportPage.data.open_graph_image.url
              : '/ATHLYZER_OG.jpg',
          },
        ],
      }
    }
  },
}
